import BaseModal from "./BaseModal";
import HeadingOne from "./HeadingOne";

function displayFilterDialog(title: string): JSX.Element {
  return (
    <div className="mb-4 flex items-center justify-center ">
      <HeadingOne>{title}</HeadingOne>
    </div>
  );
}

const parentDivStyles = "p-6 xs:w-96 sm:w-full sm:max-w-screen-sm max-h-full";

interface Props {
  children: React.ReactElement;
  title: string;
  closeModal: () => void;
  open: boolean;
}
export default function FilterModal(props: Props): JSX.Element {
  const titleComponent = displayFilterDialog(props.title);
  return (
    <BaseModal
      open={props.open}
      title={titleComponent}
      closeModal={props.closeModal}
      parentDivStyles={parentDivStyles}
    >
      {props.children}
    </BaseModal>
  );
}
